import React, { useState } from "react";
import {
  Button,
  Image,
  message,
  Popconfirm,
  Space,
  Table,
  Tag,
  Popover,
  theme,
} from "antd";
import tagStyles from "../../../styles/Custom/Tag.module.css";
import dayjs from "dayjs";
import { capitalizeFirstLetter, formatToINR } from "../../../helpers/utility";
import { shareBillApi } from "../../../services/receptionist.services";
import exportIcon from "../../../assets/receptionistIcons/exportIcon.svg";
import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import DeletePaymentModal from "../DeletePaymentModal";
import CommonPopOver from "../../PatientsIP/ReceptionistIp/CommonPopOver";
import ActionIconButton from "../../ui/ActionIconButton";
const { useToken } = theme;
const RecordPayments = ({
  paymentData,
  bill_id,
  type,
  op,
  refreshData,
  billStatus,
}) => {
  const { token } = useToken();
  const activePatient = billStatus?.data?.admission?.is_active;
  const [editData, setEditData] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const printBill = async (id, payment_id) => {
    const submitParams = `type=payment&payment_id=${payment_id}&share=download`;

    try {
      const resp = await shareBillApi(id, submitParams);
      const s3Link = resp?.data?.data; // Assuming the S3 link is in res.data.data
      if (s3Link) {
        window.open(s3Link, "_blank"); // Open the link in a new tab
      } else {
        message.error("Failed to retrieve download link.");
      }
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.message);
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => dayjs(value).format("MMM,DD"),
      width: "20%",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: "20%",
      render: (value) => value && formatToINR(value),
    },
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
      width: "20%",
      render: (value, record) => (
        <Tag color="purple" className={tagStyles.mdRndTag}>
          {value}
          {record?.other_mode ? `-${record?.other_mode}` : null}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value, record) => {
        return (
          <Space>
            <Tag color={value === "paid" ? "green" : "orange"}>
              {value === "delete_requested"
                ? "Delete Requested"
                : capitalizeFirstLetter(value)}
            </Tag>
            {record?.payment_delete_request_reason && (
              <CommonPopOver record={record} />
            )}
          </Space>
        );
      },
    },
    // ...(type
    //   ? [
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <ActionIconButton
            aria-label="Download payment"
            onClick={() => printBill(bill_id, record?.id)}
          >
            <Image
              src={exportIcon}
              alt="export"
              preview={false}
              style={{ cursor: "pointer", width: "22px" }}
            />
          </ActionIconButton>
          {record?.status !== "delete_requested" &&
            activePatient &&
            !record?.payment_delete_rejected && (
              <Popconfirm
                title="Sure to raise delete request?"
                onConfirm={() => {
                  setEditData(record?.id);
                  setOpenDeleteModal(true);
                }}
              >
                <Button
                  type="text"
                  danger
                  className="ui-action-icon"
                  aria-label="Delete"
                  icon={<DeleteOutlined />}
                />
              </Popconfirm>
            )}
        </Space>
      ),
    },
    //   ]
    // : []),
  ];
  return (
    <>
      <Table
        dataSource={paymentData?.payments}
        title={() => (
          <div className="flex-between">
            <>Payments </>
            {!op && (
              <Tag color="blue">
                Total Amount Paid:
                {formatToINR(paymentData?.total_paid_amount)}
              </Tag>
            )}
          </div>
        )}
        columns={columns}
        pagination={false}
      />
      {openDeleteModal && (
        <DeletePaymentModal
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          editData={editData}
          refresh={refreshData}
        />
      )}
    </>
  );
};

export default RecordPayments;
